// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.view-footer-con {
    width: 100%;
    display: flex;
    align-items: center;
}

.view-footer-layout {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    color: #696969;
}

.view-footer-words {
    font-family: Segoe UI, sans-serif;
    font-weight: 400;
    font-style: Regular;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0px;
}

.view-footer-copyright {
    font-family: 'Segoe UI', sans-serif;
    line-height: 16px;
    margin-top: 16px;
    color: #696969;
}


.view-footer-words-underline:hover {
    color: #000F52;
}

.view-footer-words-margin a {
    color: #696969
}

.view-footer-words-hover {
    cursor: pointer;
    color: #696969;
}

.view-footer-words-hover a:hover {
    color: #3B3B3B;
}

.view-footer-words-hover:hover {
    color: #3B3B3B;
}

.view-footer-line {
    margin: 0 6px;
}`, "",{"version":3,"sources":["webpack://./src/pages/login/components/login-footer/index.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".view-footer-con {\n    width: 100%;\n    display: flex;\n    align-items: center;\n}\n\n.view-footer-layout {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    color: #696969;\n}\n\n.view-footer-words {\n    font-family: Segoe UI, sans-serif;\n    font-weight: 400;\n    font-style: Regular;\n    font-size: 12px;\n    line-height: 16px;\n    letter-spacing: 0px;\n}\n\n.view-footer-copyright {\n    font-family: 'Segoe UI', sans-serif;\n    line-height: 16px;\n    margin-top: 16px;\n    color: #696969;\n}\n\n\n.view-footer-words-underline:hover {\n    color: #000F52;\n}\n\n.view-footer-words-margin a {\n    color: #696969\n}\n\n.view-footer-words-hover {\n    cursor: pointer;\n    color: #696969;\n}\n\n.view-footer-words-hover a:hover {\n    color: #3B3B3B;\n}\n\n.view-footer-words-hover:hover {\n    color: #3B3B3B;\n}\n\n.view-footer-line {\n    margin: 0 6px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
